<template>
  <div>
    <div class="share-box">
      <div class="section">
        <div class="index">
          1
        </div>
        <h4>Invite your friend</h4>
        <p>Send the referral link to your friend and they will receive a One-time (Small) plan as they sign up.</p>
        <div>Invitation link</div>
        <aha-clipboard
          class="max-w-md mt-1 mb-4 text-xs"
          :clipboard="() => referralLink"
          :source="'referral-code'"
          @copy="copyLink()"
          v-if="referralLink"
        />
        <div class="referral-share">
          <a class="share-item" @click="fbShareLink()">
            <i class="fab fa-facebook-square fa-fw" />
          </a>
          <a class="share-item" @click="twShareLink()">
            <i class="fab fa-twitter fa-fw" />
          </a>
          <a
            class="share-item"
            :href="`mailto:?subject=Host an interactive presentation with this gift!&body=${bodyEmail} ${referralLink}`"
            @click="trackEventEmail()"
          >
            <i class="far fa-envelope fa-fw" />
          </a>
        </div>
      </div>
      <div class="section">
        <div class="index">
          2
        </div>
        <h4>Your friend host an event</h4>
        <p>Once more than 7 people join your friend's presentation,<br> their One-time plan will be activated.</p>
      </div>
      <div class="section">
        <div class="index">
          3
        </div>
        <h4>Get credits</h4>
        <p>You earn 5 USD in your credit balance, up to a maximum of 100 USD.</p>
      </div>
    </div>

    <a class="absolute underline cursor-pointer term text-base-80 left-6 bottom-4" href="https://ahaslides.com/terms/referral-programme/" target="_blank">
      Terms and Conditions
    </a>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import config from '@/config'
import Utils from '@/util'
import UserApi from '@/api/user'

export default {
  name: 'ReferralCodeModal',
  data() {
    return {
      bodyEmail: "Join me on #AhaSlides' interactive presentation software! Take this free one-time plan to host live polls, word clouds, brainstorms and quizzes for up to 30 people!",
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    referralLink() {
      return `${config.presenterDomain}/pages/register?referral-code=${this.currentUser.referralCode}`
    },
  },
  async mounted() {
    if (!this.currentUser.referralCode) {
      const currentUser = await UserApi.getUser()
      this.$store.state.currentUser.referralCode = currentUser.referralCode
    }
  },
  methods: {
    trackEventEmail() {
      Utils.gaTrackEvent(
        'Presenter Referral Program',
        'Presenter Referral Program > Click Share Email ',
        'Share link referral to email',
      )
    },
    copyLink() {
      Utils.showToastSuccess('Link copied!')
      Utils.gaTrackEvent(
        'Presenter Referral Program',
        'Presenter Referral Program > Click Copy Link',
        'Click copy link',
      )
    },
    fbShareLink() {
      const linkClick = `${config.presenterDomain}/pages/register?referral-code=${this.currentUser.referralCode}`
      const href = encodeURIComponent(linkClick)
      const redirectUri = encodeURIComponent('https://www.facebook.com')
      const appId = 938819863278189

      Utils.gaTrackEvent(
        'Presenter Referral Program',
        'Presenter Referral Program > Click Share Facebook ',
        'Share link referral to facebook',
      )

      const link = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${href}&redirect_uri=${redirectUri}`
      window.open(link, '_blank')
    },
    twShareLink() {
      const linkClick = `${config.presenterDomain}/pages/register?referral-code=${this.currentUser.referralCode}`
      const href = encodeURIComponent(linkClick)
      const text = encodeURIComponent("Join me on #AhaSlides' interactive presentation software! Take this free one-time plan to host live polls, word clouds, brainstorms and quizzes for up to 30 people!")

      Utils.gaTrackEvent(
        'Presenter Referral Program',
        'Presenter Referral Program > Click Share Facebook ',
        'Share link referral to twitter',
      )

      const link = `https://twitter.com/intent/tweet?text=${text}&url=${href}`
      window.open(link, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.referral-share {
  .share-item {
    display: inline-block;
    font-size: 23px;
    padding: 10px;
    cursor: pointer;

    .fa-facebook-square {
      color: #3b5998;
    }

    .fa-twitter {
      color: #00aced;
    }
  }
}
.share-box {
  margin-left: 16px;

  .section {
    position: relative;
    padding-bottom: 16px;
    border-left: 1px dashed #D3D7E1;
    padding-left: 28px;

    &:last-child {
      border-left: none;
    }
    h4 {
      color: #282E3E;
      font-weight: bold;
      margin-bottom: 2px;
    }

    p {
      margin-bottom: 16px;
    }
    .index {
      position: absolute;
      top: 0;
      left: -13px;
      width: 24px;
      height: 24px;
      background-color: #EFF1F7;
      border-radius: 24px;
      text-align: center;
      line-height: 24px;
      font-weight: bold;;
    }
  }
}
</style>
